/* BejModaXL — core theme behavior (vanilla JS, no build step required) */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  /* ---------------------------------------------------------------------
   * Scroll progress bar
   * ------------------------------------------------------------------- */
  function initScrollProgress() {
    var bar = document.querySelector("[data-scroll-progress]");
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var scrollable = h.scrollHeight - h.clientHeight;
      var pct = scrollable > 0 ? (h.scrollTop / scrollable) * 100 : 0;
      bar.style.width = pct + "%";
      ticking = false;
    }
    document.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------------
   * Header: transparent -> solid on scroll, hide-on-scroll-down (optional)
   * ------------------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;
    var threshold = 40;
    function update() {
      if (window.scrollY > threshold) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    }
    document.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------------
   * Back to top
   * ------------------------------------------------------------------- */
  function initBackToTop() {
    var btn = document.querySelector("[data-back-to-top]");
    if (!btn) return;
    function toggle() {
      btn.classList.toggle("is-visible", window.scrollY > window.innerHeight * 0.8);
    }
    document.addEventListener("scroll", toggle, { passive: true });
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    toggle();
  }

  /* ---------------------------------------------------------------------
   * Fade-up on scroll (IntersectionObserver)
   * ------------------------------------------------------------------- */
  function initAnimateOnScroll() {
    var els = document.querySelectorAll("[data-animate]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
   * Generic drawer / modal open-close (cart, search, filter, mobile menu)
   * Usage: elements with [data-drawer-open="id"] / [data-drawer-close="id"]
   * targets: [data-drawer="id"]
   * ------------------------------------------------------------------- */
  var lastFocused = null;
  function openDrawer(id) {
    var el = document.querySelector('[data-drawer="' + id + '"]');
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open-lock");
    var focusable = el.querySelector("button, [href], input, [tabindex]");
    if (focusable) focusable.focus();
  }
  function closeDrawer(id) {
    var el = document.querySelector('[data-drawer="' + id + '"]');
    if (!el) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open-lock");
    if (lastFocused) lastFocused.focus();
  }
  function initDrawers() {
    document.addEventListener("click", function (e) {
      var openTrigger = e.target.closest("[data-drawer-open]");
      if (openTrigger) {
        e.preventDefault();
        openDrawer(openTrigger.getAttribute("data-drawer-open"));
        return;
      }
      var closeTrigger = e.target.closest("[data-drawer-close]");
      if (closeTrigger) {
        e.preventDefault();
        closeDrawer(closeTrigger.getAttribute("data-drawer-close"));
        return;
      }
      var overlay = e.target.closest("[data-drawer-overlay]");
      if (overlay) {
        closeDrawer(overlay.getAttribute("data-drawer-overlay"));
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        var openEl = document.querySelector(".drawer.is-open, .modal.is-open");
        if (openEl) closeDrawer(openEl.getAttribute("data-drawer"));
      }
    });
  }
  window.BejModaXL = window.BejModaXL || {};
  window.BejModaXL.openDrawer = openDrawer;
  window.BejModaXL.closeDrawer = closeDrawer;

  /* ---------------------------------------------------------------------
   * Lazy image fade-in once loaded
   * ------------------------------------------------------------------- */
  function initImageFade() {
    document.addEventListener("load", function (e) {
      if (e.target.tagName === "IMG") {
        e.target.classList.add("is-loaded");
      }
    }, true);
  }

  /* ---------------------------------------------------------------------
   * Product card: renk seçici (gerçek fotoğraf swatch) -> ana görseli değiştir
   * ------------------------------------------------------------------- */
  function initCardSwatches() {
    document.addEventListener("click", function (e) {
      var swatch = e.target.closest("[data-swatch]");
      if (!swatch) return;
      var card = swatch.closest("[data-product-card]");
      if (!card) return;
      card.querySelectorAll("[data-swatch]").forEach(function (s) { s.classList.remove("is-active"); });
      swatch.classList.add("is-active");
      var mainImg = card.querySelector("[data-main-image]");
      var newSrc = swatch.getAttribute("data-image");
      if (mainImg && newSrc) mainImg.src = newSrc;
    });
  }

  /* ---------------------------------------------------------------------
   * Wishlist (localStorage tabanlı, hesap gerektirmez)
   * ------------------------------------------------------------------- */
  var WISHLIST_KEY = "bejmodaxl:wishlist";
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    updateWishlistCount();
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll("[data-wishlist-count-value]").forEach(function (el) {
      el.textContent = count;
    });
  }
  function syncWishlistButtons() {
    var ids = getWishlist().map(String);
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var id = btn.getAttribute("data-product-id");
      btn.classList.toggle("is-active", ids.indexOf(id) !== -1);
    });
  }
  function initWishlist() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-wishlist-toggle]");
      if (!btn) return;
      var id = btn.getAttribute("data-product-id");
      var ids = getWishlist().map(String);
      var idx = ids.indexOf(id);
      if (idx === -1) ids.push(id); else ids.splice(idx, 1);
      setWishlist(ids);
      btn.classList.toggle("is-active", idx === -1);
    });
    syncWishlistButtons();
    updateWishlistCount();
  }
  window.BejModaXL = window.BejModaXL || {};
  window.BejModaXL.getWishlist = getWishlist;

  /* ---------------------------------------------------------------------
   * Hızlı İncele: Section Rendering API ile ürün içeriğini modal'a çeker
   * ------------------------------------------------------------------- */
  function initQuickView() {
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-quick-view-open]");
      if (!trigger) return;
      var url = trigger.getAttribute("data-product-url");
      var modal = document.getElementById("QuickViewModal");
      if (!url || !modal) return;
      modal.innerHTML = '<div class="quick-view-modal__panel"><p class="text-muted">Yükleniyor…</p></div>';
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drawer-open-lock");
      fetch(url + (url.indexOf("?") > -1 ? "&" : "?") + "section_id=quick-view")
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var content = doc.querySelector("[data-quick-view-content]");
          modal.innerHTML = '<div class="quick-view-modal__panel">' +
            '<button type="button" class="drawer__close quick-view-modal__close" data-quick-view-close aria-label="Kapat">' +
            '</button>' + (content ? content.outerHTML : "") + "</div>";
          var closeBtn = modal.querySelector("[data-quick-view-close]");
          if (closeBtn) closeBtn.innerHTML = document.querySelector("#IconCloseTemplate") ? "" : "&times;";
        })
        .catch(function () {
          modal.innerHTML = '<div class="quick-view-modal__panel"><p>Ürün yüklenemedi. <a href="' + url + '">Ürün sayfasına git</a></p></div>';
        });
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-quick-view-close]") || e.target.id === "QuickViewModal") {
        var modal = document.getElementById("QuickViewModal");
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("drawer-open-lock");
      }
    });
  }

  /* ---------------------------------------------------------------------
   * <recommendations-products> — Section Rendering API ile benzer ürün /
   * birlikte alınanlar bloklarını asenkron doldurur.
   * ------------------------------------------------------------------- */
  if (!window.customElements.get("recommendations-products")) {
    class RecommendationsProducts extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(
            function (html) {
              var doc = new DOMParser().parseFromString(html, "text/html");
              var content = doc.querySelector("recommendations-products");
              if (content && content.innerHTML.trim().length) {
                this.innerHTML = content.innerHTML;
                initAnimateOnScroll();
              } else {
                this.remove();
              }
            }.bind(this)
          )
          .catch(function () {});
      }
    }
    window.customElements.define("recommendations-products", RecommendationsProducts);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initScrollProgress();
    initHeader();
    initBackToTop();
    initAnimateOnScroll();
    initDrawers();
    initImageFade();
    initCardSwatches();
    initWishlist();
    initQuickView();
  });
})();
